import { render } from "./ContactIcons.vue?vue&type=template&id=0f465502&scoped=true&ts=true"
import script from "./ContactIcons.vue?vue&type=script&lang=ts"
export * from "./ContactIcons.vue?vue&type=script&lang=ts"

import "./ContactIcons.vue?vue&type=style&index=0&id=0f465502&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f465502"]])

export default __exports__